import {css} from 'styled-components'
import {palette} from 'styled-tools'

export const refinementStyle = css`
  .ais-RefinementList-item {
    margin-bottom: 6px;
    cursor: pointer;
  }

  .ais-RefinementList-label {
    display: flex;
    align-items: center;
    color: ${palette('blue')};
    cursor: pointer;

    input[type='checkbox'] {
      margin-right: 12px;
      cursor: pointer;

      &:checked ~ .checkmark {
        background-color: ${palette('blue')};
      }

      &::after {
        border-color: ${palette('blue')};
      }
    }

    .ais-RefinementList-count {
      color: ${palette('ui50Solid')};
      margin-left: 4px;

      &::before {
        content: '(';
      }

      &::after {
        content: ')';
      }
    }
  }
`
